export const emailValidator = (control) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!control.value) {
        return null;
    } else if (!emailPattern.test(control.value)) {
        return { invalidEmail: true };
    }
    return null;
};


export const positiveNumberValidator = (control) => {
    const raw = control?.value;
    if (raw === null || raw === undefined || raw === "") return null; // treat empty as valid here
    const str = typeof raw === "string" ? raw.replace(/,/g, "") : String(raw);
    const n = parseFloat(str);
    return isNaN(n) || n < 0
        ? { positiveNumber: { valid: false, actual: control.value, message: "Enter a number equal to or greater than 0." } }
        : null;
};

export const isGreaterThanZero = (control) => {
    const raw = control?.value;
    if (raw === null || raw === undefined || raw === "") return null; // treat empty as valid here
    const str = typeof raw === "string" ? raw.replace(/,/g, "") : String(raw);
    const n = parseFloat(str);
    return isNaN(n) || n <= 0
        ? { isGreaterThanZero: { valid: false, actual: control.value, message: "Value should be greater than 0." } }
        : null;
};